export default "__VITE_ASSET__BpKGLi_k__"